export function initializeTenantConfig() {

    const generic = {
        header: {
            ribbon: true
        },
        footer: {
            privacySettings: true
        },
        dashboard: {
            showTenantDropdown: true
        },
        sidebar: {
            showDynamicCategories: true
        },
        publishToTenant: {
            showDisabledTenants : true
        },
        productCard: {
            showMoreDetails: true
        }
    };

    const tenantConfig = {
        mkos: {
            header: { ...generic.header },
            footer: { ...generic.footer },
            dashboard: { ...generic.dashboard },
            sidebar: { ...generic.sidebar },
            publishToTenant: { ...generic.publishToTenant },
            productCard: { ...generic.productCard }
        },
        mkosint: {
            header: { ...generic.header },
            footer: { ...generic.footer },
            dashboard: { ...generic.dashboard },
            sidebar: { ...generic.sidebar },
            publishToTenant: { ...generic.publishToTenant },
            productCard: { ...generic.productCard }
        },
        condense: {
            header: {
                ...generic.header,
                ribbon: false
            },
            footer: {
                ...generic.footer,
                privacySettings: false
            },
            dashboard: {
                ...generic.dashboard,
                showTenantDropdown: false
            },
            sidebar: {
                ...generic.sidebar,
                showDynamicCategories: false
            },
            publishToTenant: { 
                ...generic.publishToTenant,
                showDisabledTenants : false, 
            },
            productCard: {
                ...generic.productCard,
                showMoreDetails: false
            }
        }
    };

    const configKey = process.env.REACT_APP_SUB_DOMAIN ? process.env.REACT_APP_SUB_DOMAIN : process.env.REACT_APP_SELLER_TENANT_ID;

    return (dispatch) => {
        if (tenantConfig[configKey]) {
            dispatch({
                type: 'SET_TENANT_CONFIGURATION',
                payload: tenantConfig[configKey],
            });
        }
    };
}